import getLaunchTilesDefaultBehavior from './getLaunchTilesDefaultBehavior';

import type { ViewData } from 'owa-graph-schema';

const AppBarModelControl: ViewData = {
    __typename: 'ViewData',
    appBarControl: {
        __typename: 'AppBarControl',
        id: 'AppBarControl',
        rootNavigationAriaLabel: 'left-rail-appbar',
        animateSelection: true,
        tileBehavior: getLaunchTilesDefaultBehavior(),
        localizedStrings: {
            flyoutButtonTitle: 'More apps',
            flyoutEmptyStateMessage: 'No apps',
        },
    },
};

export default AppBarModelControl;
